import { render, staticRenderFns } from "./CScatter.vue?vue&type=template&id=59cc49c6&scoped=true&"
import script from "./CScatter.vue?vue&type=script&lang=js&"
export * from "./CScatter.vue?vue&type=script&lang=js&"
import style0 from "./CScatter.vue?vue&type=style&index=0&id=59cc49c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cc49c6",
  null
  
)

export default component.exports